import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["helpText", "isRequired", "isSaving"];
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SavableFormLabel(_ref) {
  let {
      helpText = undefined,
      isRequired = false,
      isSaving = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const props = Object.assign({
    helpText,
    isRequired,
    isSaving
  }, rest);
  const [showResult, setShowResult] = useState(true);
  const [failed, setFailed] = useState(true);
  useEffect(() => {
    if (props.isSaving) {
      setShowResult(false);
      setFailed(false);
      return () => {};
    } else {
      const resultTimeout = setTimeout(() => setShowResult(true), 100);
      const failedTimeout = setTimeout(() => setFailed(true), 2000);
      return () => {
        clearTimeout(resultTimeout);
        clearTimeout(failedTimeout);
      };
    }
  }, [props.isSaving]);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "row",
    justify: "start",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(FormLabel, {
        "data-test-id": "form-label",
        required: props.isRequired,
        children: [props.label, props.helpText ? /*#__PURE__*/_jsx(HelpIcon, {
          tooltipPlacement: "bottom",
          title: props.helpText,
          marginInlineStart: "200"
        }) : null]
      })
    }), /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      direction: "row",
      justify: "end",
      wrap: "wrap",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        "data-test-id": "loading-spinner",
        failed: failed,
        showResult: showResult,
        size: "xs"
      })
    })]
  });
}
SavableFormLabel.propTypes = {
  helpText: PropTypes.node,
  isRequired: PropTypes.bool,
  isSaving: PropTypes.bool,
  label: PropTypes.node.isRequired
};
export default SavableFormLabel;